<ng-container *ngIf="currentPageActions$ | async as currentPageActions">
  <div *ngIf="currentPageActions.isPlatformEnabled" class="row d-flex align-items-start">
    <label class="col-6 mt-2 required">Platforms</label>
    <osn-cxb-multi-select
      class="col"
      *ngIf="platformOptions"
      [isFixedWidth]="true"
      [formControl]="platformIdsControl"
      [options]="platformOptions"
      [errorLabel]="platformIdsControl | missingPlatformSelectionPrompt"
      [emitValueOnRegisterOnChange]="emitValueOnRegisterOnChange"
      filterPlaceholderLabel="Filter in platforms..."
      filterNoEntriesFoundLabel="No platform found"
      placeholder="Select target platforms"
      [data-testid]="testId"
    ></osn-cxb-multi-select>
  </div>
</ng-container>
